import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {CausaliGiornata, PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {DateTime} from "luxon";
import {Calc, Coppia} from "@commons/mapping/Calc";
import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

export type TipoControllo =
    "NESSUN_CONTROLLO"
    | "COME_PREVISTO"
    | "COME_MANCANTE"
    | "COME_INTERVALLO"
    | "COME_ORDINARIO"
    | "COME_ORDINARIO_D"
    | "COME_ORDINARIO_N"
    | "COME_EXTRA"
    | "COME_EXTRA_D"
    | "COME_EXTRA_N"
    | "COME_INTERVALLO_EFF";
export type AzioneXGiuPresente = "SALTA" | "AGGIUNGI" | "SOTTRAI" | "SOSTITUISCI";
export type TipologiaGiornata = "QUALSIASI" | "SPECIFICA_SETTIMANALE" | "SPECIFICA_MENSILE" | "GIORNI_FERIALI" | "GIORI_FESTIVI" | "RIPOSO1" | "RIPOSO2" | "FS_SU_RIPOSO1" | "FS_SU_RIPOSO2";
export type ControlloSuPrevisto = "QUALSIASI" | "CON_PREVISTO" | "SENZA_PREVISTO";
export type ControlloSuOre = "QUALSIASI" | "NON_ZERO" | "DALLE_ALLE" | "DALLE_ALLE_PARZIALE" | "MAGGIOREU_DI" | "MINOREU_DI" | "DIURNE_MAGGIOREU_DI" | "NOTTURNE_MAGGIOREU_DI";
export type ControlloAltriGiustificativi = "NESSUN_CONTROLLO" | "SE_PRESENTE" | "SE_NON_PRESENTE" | "PRESENTE_MAGGIOREU_DI" | "PRESENTE_MINOREU_DI";
export type ControlloAccumulo = "NESSUN_CONTROLLO" | "SE_VERO" | "SE_FALSO";

export interface GiustificazioneRecord {
    codGiu: string;
    controllo: TipoControllo;
    ore: number;
}

export class GiustificazioneRecord {
    static isValid = function (that: GiustificazioneRecord) {
        return (that && that.codGiu) ? true : false;
    };
}

export interface GiustificazioneAssenzaRecord extends GiustificazioneRecord {
}

export interface GiustificazioneAutoRecord extends GiustificazioneRecord, URIAndTrace {
    idAziendaTabelle: number,
    idGiuRic: number,
    descrizione: string,
    azioneXGiuPresente: AzioneXGiuPresente,
    tipologiaGiornata: TipologiaGiornata,
    lunedi: boolean,
    martedi: boolean,
    mercoledi: boolean,
    giovedi: boolean,
    venerdi: boolean,
    sabato: boolean,
    domenica: boolean,
    giornoMese: number,
    controlloSuPrevisto: ControlloSuPrevisto,
    controlloSuOreLavorate: ControlloSuOre,
    dalleXLavorate: string,
    alleXLavorate: string,
    oreRifXLavorate: number,
    controlloSuOreMancanti: ControlloSuOre,
    dalleXMancante: string,
    alleXMancante: string,
    oreRifXMancante: number,
    controlloAltriGiu: ControlloAltriGiustificativi,
    codGiuRif: string,
    oreRifXAltriGiu: number,
    controlloAccumulo: ControlloAccumulo,
    codiceAccumulo: string,
    usaMancanteLavorato: boolean,
    codGiuDaSostituire: string,
    valMin: number,
    valMax: number,
}

function _isNull(timb: string | null) {
    return (timb === null || timb === '');
}

export class GiustificazioneAutoRecord {
    static factory: ObjectFactory<GiustificazioneAutoRecord> = (json?) => {
        return merge<GiustificazioneAutoRecord, Partial<GiustificazioneAutoRecord> | undefined>({
            codGiu: '',
            controllo: 'NESSUN_CONTROLLO',
            ore: 0,
            idAziendaTabelle: 0,
            idGiuRic: 0,
            descrizione: '',
            azioneXGiuPresente: 'SALTA',
            tipologiaGiornata: 'QUALSIASI',
            lunedi: false,
            martedi: false,
            mercoledi: false,
            giovedi: false,
            venerdi: false,
            sabato: false,
            domenica: false,
            giornoMese: 0,
            controlloSuPrevisto: 'QUALSIASI',
            controlloSuOreLavorate: 'QUALSIASI',
            dalleXLavorate: '',
            alleXLavorate: '',
            oreRifXLavorate: 0,
            controlloSuOreMancanti: 'QUALSIASI',
            dalleXMancante: '',
            alleXMancante: '',
            oreRifXMancante: 0,
            controlloAltriGiu: 'NESSUN_CONTROLLO',
            codGiuRif: '',
            oreRifXAltriGiu: 0,
            controlloAccumulo: 'NESSUN_CONTROLLO',
            codiceAccumulo: '',
            usaMancanteLavorato: false,
            codGiuDaSostituire: '',
            valMin: 0,
            valMax: 0,
            URI: null
        }, json);
    }
    static getDalleXLavorate = (that: GiustificazioneAutoRecord) => {
        return _isNull(that.dalleXLavorate) ? null : parseInt(that.dalleXLavorate);
    };
    static getAlleXLavorate = (that: GiustificazioneAutoRecord) => {
        return _isNull(that.alleXLavorate) ? null : parseInt(that.alleXLavorate);
    };
    static getDalleXMancante = (that: GiustificazioneAutoRecord) => {
        return _isNull(that.dalleXMancante) ? null : parseInt(that.dalleXMancante);
    };
    static getAlleXMancante = (that: GiustificazioneAutoRecord) => {
        return _isNull(that.alleXMancante) ? null : parseInt(that.alleXMancante);
    };

    static chkTipologiaGiornata = (that: GiustificazioneAutoRecord, day: PresenzeGiornataPlusRecord): boolean => {
        //const weekday = DateTime.fromISO(day.dtGiornata!).weekday; // Get the day of the week. 1 is Monday and 7 is Sunday
        const weekday = PresenzeGiornataPlusRecord.getDayOfWeek(day); // Get the day of the week. 1 is Monday and 7 is Sunday

        switch (that.tipologiaGiornata) {
            case 'QUALSIASI':
                return true;
            case 'SPECIFICA_SETTIMANALE': {
                var applica = false;
                applica = applica || (that.lunedi && (weekday === 1));
                applica = applica || (that.martedi && (weekday === 2));
                applica = applica || (that.mercoledi && (weekday === 3));
                applica = applica || (that.giovedi && (weekday === 4));
                applica = applica || (that.venerdi && (weekday === 5));
                applica = applica || (that.sabato && (weekday === 6));
                applica = applica || (that.domenica && (weekday === 7));
                return applica;
            }
            case 'SPECIFICA_MENSILE':
                return day.giorno === that.giornoMese;
            case 'GIORNI_FERIALI':
                return !(day.giorno6 || day.giorno7 || day.festivo);
            case 'GIORI_FESTIVI':
                return day.festivo;
            case 'RIPOSO1':
                return day.giorno6;
            case 'RIPOSO2':
                return day.giorno7;
            case 'FS_SU_RIPOSO1':
                return day.festivo && day.giorno6;
            case 'FS_SU_RIPOSO2':
                return day.festivo && day.giorno7;
            default:
                return false;
        }
    };

    static chkGiustificativo = (that: GiustificazioneAutoRecord, causaliHH: CausaliGiornata, causaliQI: CausaliGiornata): boolean => {
        const causaliXXX = [causaliHH, causaliQI];
        switch (that.controlloAltriGiu) {
            case 'SE_PRESENTE':
            case 'PRESENTE_MAGGIOREU_DI':
            case 'PRESENTE_MINOREU_DI': {
                var applica = false;
                for (let indC = 0; indC < causaliXXX.length; ++indC) {
                    const causali = causaliXXX[indC];
                    for (const causale of causali) {
                        if (causale && causale.codGiu === that.codGiuRif) {
                            if (that.controlloAltriGiu === 'PRESENTE_MAGGIOREU_DI') {
                                applica = causale.quantita >= that.oreRifXAltriGiu;
                            } else if (that.controlloAltriGiu === 'PRESENTE_MINOREU_DI') {
                                applica = causale.quantita <= that.oreRifXAltriGiu;
                            } else {
                                applica = true;
                            }
                        }
                    }
                }
                return applica;
            }

            case 'SE_NON_PRESENTE':
                for (let indC = 0; indC < causaliXXX.length; ++indC) {
                    const causali = causaliXXX[indC];
                    for (const causale of causali) {
                        if (causale && causale.codGiu === that.codGiuRif) {
                            return false;
                        }
                    }
                }
                return true;

            case 'NESSUN_CONTROLLO':
            default:
                return true;
        }
    };

    static chkOre(that: GiustificazioneAutoRecord,
                  calcLavoratoD: Calc,
                  calcLavoratoN: Calc,
                  controlloSuOre: ControlloSuOre,
                  dalle: number,
                  alle: number,
                  oreRif: number,
                  chkMancante: boolean,
                  day: PresenzeGiornataPlusRecord,
                  mancanteLavorato: number): boolean {
        const mancante = day.totali!.hMancanti - mancanteLavorato;

        let quantita = 0;
        switch (controlloSuOre) {
            case 'QUALSIASI':
                return true;

            case 'NON_ZERO':
                if (chkMancante) {
                    return (mancanteLavorato + calcLavoratoD.getCount() + calcLavoratoN.getCount()) === 0;
                } else {
                    return (mancanteLavorato + calcLavoratoD.getCount() + calcLavoratoN.getCount()) > 0;
                }

            case 'DALLE_ALLE': {
                const cIntervalloDaTestare = new Coppia(dalle, alle).calc;
                quantita += calcLavoratoD.getCount(cIntervalloDaTestare);
                quantita += calcLavoratoN.getCount(cIntervalloDaTestare);
                if (chkMancante) {
                    return quantita === 0;
                } else {
                    return quantita === cIntervalloDaTestare.getCount();
                }
            }
            case 'DALLE_ALLE_PARZIALE': {
                const cIntervalloDaTestare = new Coppia(dalle, alle).calc;
                quantita += calcLavoratoD.getCount(cIntervalloDaTestare);
                quantita += calcLavoratoN.getCount(cIntervalloDaTestare);
                if (chkMancante) {
                    return quantita < cIntervalloDaTestare.getCount();
                } else {
                    return quantita > 0;
                }
            }

            case 'MAGGIOREU_DI':
                if (chkMancante) {
                    return mancante >= oreRif;
                } else {
                    return mancanteLavorato + calcLavoratoD.getCount() + calcLavoratoN.getCount() >= oreRif;
                }

            case 'MINOREU_DI':
                if (chkMancante) {
                    return mancante <= oreRif;
                } else {
                    return mancanteLavorato + calcLavoratoD.getCount() + calcLavoratoN.getCount() <= oreRif;
                }

            case 'DIURNE_MAGGIOREU_DI':
                return mancanteLavorato + calcLavoratoD.getCount() >= oreRif;

            case 'NOTTURNE_MAGGIOREU_DI':
                return mancanteLavorato + calcLavoratoN.getCount() >= oreRif;
        }
        return false;

    }
}